import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { Box, DataTable } from '../../../../common/components';
import {
  applyFilter,
  clearData,
} from '../../../../common/components/DataTable/redux/dataTableActions';
import formatDateTime from '../../../../helpers/formatDateTime';
import startCase from '../../../../helpers/socratesLodash/startCase';

/*****************************
 BrokerMessages DataTable
 *****************************/

export default class BrokerApplicationList extends Component {
  componentWillUnmount() {
    clearData('brokerMessage');
  }

  handleRowClick(row) {
    const { dispatch } = this.props;
    dispatch(push('/admin/broker-messages/' + row.id));
  }

  handleSearchUpdate = (event) => {
    const { dispatch } = this.props;
    dispatch(applyFilter('brokerMessage', 'filter[name]', event.target.value));
  };

  handleReferenceSearchUpdate = (event) => {
    const { dispatch } = this.props;
    dispatch(applyFilter('brokerMessage', 'filter[reference]', event.target.value));
  };

  render() {
    const businessTypeFormat = (value) => {
      return `${startCase(value)}`;
    };
    return (
      <div>
        <Box>
          <Row>
            <Col sm={4}>
              <ControlLabel>Search Name</ControlLabel>
              <FormControl onChange={this.handleSearchUpdate} />
            </Col>
            <Col sm={4}>
              <ControlLabel>Search Reference</ControlLabel>
              <FormControl onChange={this.handleReferenceSearchUpdate} />
            </Col>
          </Row>
        </Box>

        <Box>
          <DataTable
            source="brokers/contacts"
            name="brokerMessage"
            showTotal
            onRowSelect={this.handleRowClick.bind(this)}
          >
            <TableHeaderColumn dataField="id" isKey hidden />

            <TableHeaderColumn dataField="reference" width={'10%'}>
              Reference
            </TableHeaderColumn>

            <TableHeaderColumn dataField="name" dataSort width={'60%'}>
              Name
            </TableHeaderColumn>

            <TableHeaderColumn dataField="company" dataSort width={'10%'}>
              Company
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="business_type"
              dataSort
              width={'10%'}
              dataFormat={businessTypeFormat}
            >
              Type
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="created_at"
              dataSort
              dataFormat={formatDateTime}
              width={'10%'}
            >
              Created
            </TableHeaderColumn>
          </DataTable>
        </Box>
      </div>
    );
  }
}
